import * as Scrivito from "scrivito";
import categoriesProducts from "config/locals/keysCategoriesProducts.json";
import categories from "config/locals/keysCategories.json";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const Document = Scrivito.provideObjClass("Document", {
  attributes: {
    complementaryText: "string",
    fileTypeDe: "string",
    filegroupDe: "string",
    idNr: "string",
    lastSizeChange: "date",
    sortKey: "integer",
    blob: "binary",
    categorySegments: ["multienum", { values: categoriesProducts.segments }],
    categorySubsegments: [
      "multienum",
      { values: categoriesProducts.subsegments },
    ],
    categoryGroups: ["multienum", { values: categoriesProducts.groups }],
    categorySeries: ["multienum", { values: categoriesProducts.series }],
    categoryDocumentTypes: ["multienum", { values: categories.documentTypes }],
    categoryDownloadType: ["enum", { values: categories.downloadTypes }],
    ...defaultPageAttributes,
    ...metadataAttributes,
  },
  extractTextAttributes: ["blob:text"],
});

export default Document;
